import { useQuery } from "@apollo/react-hooks";
import gql from "graphql-tag";
import { teamUserFragment } from "core/queries/GetTeam";
import {
  SearchForUsers as SearchForUsersGenerated,
  SearchForUsersVariables as SearchForUsersVariablesGenerated,
  SearchForUsers_searchWithMetadata_items_resource_User as UserDataGenerated,
} from "core/queries/__generated__/SearchForUsers";
import { SortAscDesc, SortColumn } from "typings/globalGQLTypes";

export interface SearchForUsersVariables
  extends SearchForUsersVariablesGenerated {}
export interface SearchForUsersResponse extends SearchForUsersGenerated {}
export interface UserData extends UserDataGenerated {}

export const searchForUsers = gql`
  query SearchForUsers(
    $searchTerm: String!
    $filters: SearchFilterInput
    $pagination: Pagination
    $sorting: Sorting
  ) {
    searchWithMetadata(
      searchTerm: $searchTerm
      resultType: user
      filters: $filters
      pagination: $pagination
      sorting: $sorting
    ) {
      total
      cursor
      hasMore
      items {
        id
        title
        subtitle
        description
        resource {
          ... on User {
            id
            ...TeamUser
          }
        }
      }
    }
  }
  ${teamUserFragment}
`;

export interface UseSearchForUsersOptions {
  skip?: boolean;
  variables: SearchForUsersVariables;
}

export const useSearchForUsers = ({
  skip = false,
  variables,
}: UseSearchForUsersOptions) =>
  useQuery<SearchForUsersResponse, SearchForUsersVariables>(searchForUsers, {
    fetchPolicy: "network-only",
    skip,
    variables: {
      filters: {},
      pagination: { cursor: "0", limit: 25 },
      // TODO: new SortColumn?
      sorting: { column: SortColumn.created_at, order: SortAscDesc.desc },
      ...variables,
    },
  });
